import {
  Badge,
  Card,
  Image,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { IconStar } from "@tabler/icons-react";

const partners = [
  {
    name: "KM24",
    description:
      "Premium business intelligence datasets covering market trends, consumer behavior, and economic indicators. Access exclusive insights for data-driven decisions.",
    coverImage: "/data/discover/partners/km24.png",
    badge: "Premium",
    color: "orange",
  },
  {
    name: "Experian",
    description:
      "Comprehensive consumer and business data with advanced analytics capabilities. Trusted by leading organizations for credit, marketing, and risk management insights.",
    coverImage: "/data/discover/partners/experian.jpg",
    badge: "Enterprise",
    color: "grape",
  },
  {
    name: "Data Partners Network",
    description:
      "A curated collection of premium datasets from verified data providers. Get access to specialized, high-quality data sources not available elsewhere.",
    coverImage: "/data/discover/partners/dpn.jpg",
    badge: "Premium",
    color: "pink",
  },
];

export function Partners() {
  return (
    <Stack gap="xl">
      <Title order={2} fw={600} fz={28}>
        Data Partners
      </Title>
      <Text c="gray.9" fz={16} lh={1.6}>
        Unlock premium datasets from our trusted partners. These paid data
        sources offer specialized insights and advanced analytics capabilities
        for professional use.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">
        {partners.map((partner) => (
          <Card
            key={partner.name}
            p={0}
            shadow="lg"
            radius="md"
            style={{
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Image
              src={partner.coverImage}
              alt={partner.name}
              height={140}
              style={{ objectFit: "cover", width: "100%" }}
            />
            <Stack
              gap="sm"
              p="lg"
              style={{ flex: 1, justifyContent: "space-between" }}
            >
              <Stack gap="sm">
                <Text fw={600} fz={18}>
                  {partner.name}
                </Text>
                <Text c="gray.9" fz={15} lh={1.6} style={{ flex: 1 }}>
                  {partner.description}
                </Text>
              </Stack>
              <Badge
                size="sm"
                variant="light"
                color={partner.color}
                leftSection={<IconStar size={12} />}
                style={{ alignSelf: "flex-start" }}
              >
                {partner.badge}
              </Badge>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
